import { Component, Input } from '@angular/core';
import {
  ProfReportSchedule,
  ProfEventRow,
  AnalyticsPeriod
} from '../../models/analytics.types';
import { EXPORT_FORMATS, ExportFormat } from '../../models/period-trends.const';

@Component({
  selector: 'tangram-pa-reports-export-tab',
  templateUrl: './reports-export-tab.component.html',
  styleUrls: ['./reports-export-tab.component.scss']
})
export class ReportsExportTabComponent {
  @Input() reportSchedules: ProfReportSchedule[] = [];
  @Input() eventRows: ProfEventRow[] = [];
  @Input() selectedPeriod: AnalyticsPeriod = 'This Month';

  exportFormats = EXPORT_FORMATS;
  selectedExportFormat: ExportFormat = 'CSV';

  toggleSchedule(schedule: ProfReportSchedule): void {
    const idx = this.reportSchedules.indexOf(schedule);
    if (idx > -1) {
      this.reportSchedules = this.reportSchedules.map((s, i) =>
        i === idx ? { ...s, enabled: !s.enabled } : s
      );
    }
  }

  exportInsights(): void {
    const rows = this.eventRows.map(r => `${r.event},${r.value},${r.uniqueUsers},${r.trend}%`);
    const csv = ['Event,Value,Unique Users,Trend', ...rows].join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `professor-analytics-${this.selectedPeriod.replace(/\s/g, '-').toLowerCase()}.${this.selectedExportFormat.toLowerCase()}`;
    a.click();
    URL.revokeObjectURL(url);
  }
}
